import { RefObject, useMemo, useState, useEffect } from 'react';
import { useLatest } from 'ahooks';
import { FULLSCREEN_META_CFG } from '../constants';

interface IFullscreenOptions {
  requestFullscreen: string;
  exitFullscreen: string;
  fullscreenElement: string;
  fullscreenEnabled: string;
  fullscreenchange: string;
  fullscreenerror: string;
}

export default function useFullScreen(
  fullScreenContent: RefObject<HTMLElement | null>,
  onFullScreenChange?: (isFullScreen: boolean) => void,
) {
  const handleFullScreenChangeHandler = useLatest<((isFullScreen: boolean) => void) | undefined>(onFullScreenChange);

  // 是否全屏
  const [isFullScreen, setIsFullScreen] = useState<boolean>(false);

  const element = useMemo<IFullscreenOptions>(() => {
    if ('webkitRequestFullscreen' in document.documentElement) return FULLSCREEN_META_CFG.WEBKIT;
    if ('mozRequestFullScreen' in document.documentElement) return FULLSCREEN_META_CFG.MOZ;
    if ('msRequestFullscreen' in document.documentElement) return FULLSCREEN_META_CFG.MS;
    return FULLSCREEN_META_CFG.DEFAULT;
  }, []);

  // 进入全屏
  const requestFullScreen = () => {
    if (fullScreenContent.current) {
      // @ts-ignore
      fullScreenContent.current[element.requestFullscreen]?.();
    }
  };

  // 退出全屏
  const exitFullScreen = () => {
    // @ts-ignore
    document[element.exitFullscreen]?.();
  };

  // 切换是否全屏
  const handleFullScreenChange = () => {
    // @ts-ignore
    const isFullScreenNew = !!document[element.fullscreenElement];
    setIsFullScreen(isFullScreenNew);
    handleFullScreenChangeHandler.current?.(isFullScreenNew);
  };

  useEffect(() => {
    document.addEventListener(element.fullscreenchange, handleFullScreenChange);

    return () => {
      document.removeEventListener(element.fullscreenchange, handleFullScreenChange);
    };
  }, []);

  return { isFullScreen, requestFullScreen, exitFullScreen };
}
